import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../extra/Pagination';
import Table from '../../extra/Table';
import Button from '../../extra/Button';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Iconb from '../../extra/Iconb';
import StaffDialogue from './StaffDialogue';
import PermissionViewDialogue from './PermissionViewDialogue';
import { warning } from '../../../util/Alert';
import { getStaff, toggleStaffStatus, deleteStaff } from '../../store/staff/staff.action';
import ToggleSwitch from '../../extra/ToggleSwitch';
import { usePermission } from '../../../hooks/usePermission';
const Staff = () => {
  const dispatch = useDispatch();

  const { can } = usePermission();
  const canCreate = can("Staff", "Create");
  const canEdit = can("Staff", "Edit");
  const canDelete = can("Staff", "Delete");

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);

  const { staff, totalStaff } = useSelector((state) => state.staff);
  const { dialogueType } = useSelector((state) => state.dialogue);



  useEffect(() => {
    dispatch(getStaff(page, size));
  }, [dispatch, page, size]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleToggle = (row) => {

    dispatch(toggleStaffStatus(row._id));
  };


  const handleDelete = (row) => {

    warning("Delete").then((result) => {
      if (result) {
        dispatch(deleteStaff(row._id));
      }
    });
  };

  const staffTable = [
    {
      Header: 'No',
      body: 'no',
      Cell: ({ index }) => (
        <span className="text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: 'Name',
      body: 'name',
      Cell: ({ row }) => (
        <span className="text-nowrap">{row?.name}</span>
      ),
    },
    {
      Header: 'Email',
      body: 'email',
      Cell: ({ row }) => (
        <span className="text-nowrap">{row?.email}</span>
      ),
    },
    {
      Header: 'Role Name',
      body: 'role',
      Cell: ({ row }) => (
        <span className="text-nowrap">{row?.role?.name || "N/A"}</span>
      ),
    },
    ...(canEdit ? [
      {
        Header: 'Status',
        body: 'isActive',
        Cell: ({ row }) => (
          <ToggleSwitch
            value={row?.isActive}
            onClick={() => handleToggle(row)}
          />
        ),
      }
    ] : []),

    ...(canEdit ? [
      {
        Header: "Edit",
        body: "",
        Cell: ({ row }) => (
          <Iconb
            newClass={`themeFont boxCenter infobtn userBtn fs-5`}
            btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
            style={{ borderRadius: "50px", margin: "auto", height: "45px", width: "45px", color: "#160d98" }}
            isImage={true}
            onClick={() => dispatch({ type: 'OPEN_DIALOGUE', payload: { type: 'staff', data: row } })}
          />
        ),
      }
    ] : []),

    ...(canDelete ? [
      {
        Header: "Delete",
        body: "",
        Cell: ({ row }) => (
          <Iconb
            newClass={`themeFont boxCenter killbtn userBtn fs-5`}
            btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
            style={{ borderRadius: "50px", margin: "auto", height: "45px", width: "45px", color: "#160d98", padding: "0px" }}
            isImage={true}
            isDeleted={true}
            onClick={() => handleDelete(row)}
          />
        ),
      }
    ] : []),

    {
      Header: "Info",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<InfoOutlined sx={{ color: '#737272' }} />}
          style={{ borderRadius: "50px", margin: "auto", height: "45px", width: "45px", color: "#160d98", padding: "0px" }}
          isImage={true}
          isDeleted={true}
          onClick={() => dispatch({ type: 'OPEN_DIALOGUE', payload: { type: 'viewPermission', data: row.role } })}
        />
      ),
    },

  ];

  return (
    <>
      {dialogueType === 'staff' && (
        <StaffDialogue page={page} size={size} />
      )}
      {dialogueType === 'viewPermission' && (
        <PermissionViewDialogue />
      )}
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Staff</div>
          <div className="sellerMain">
            <div className="tableMain mt-2 categoryTable">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-12">
                    {canCreate && (
                      <Button
                        newClass={`whiteFont`}
                        btnColor={`btnBlackPrime `}
                        btnIcon={`fa-solid fa-plus `}
                        btnName={`Add`}
                        onClick={() => {
                          dispatch({ type: 'OPEN_DIALOGUE', payload: { type: "staff" } });
                        }}
                        style={{ borderRadius: "5px", padding: "8px 32px", background: "#b93160" }}
                      />
                    )}

                  </div>
                </div>
              </div>
              <Table
                data={staff}
                mapData={staffTable}
                serverPerPage={size}
                serverPage={page}
                type={"server"}
              />
              <Pagination
                component="div"
                count={totalStaff}
                type={"server"}
                onPageChange={handlePageChange}
                serverPerPage={size}
                totalData={totalStaff}
                serverPage={page}
                setCurrentPage={setPage}
                onRowsPerPageChange={handleRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default Staff;